"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockToggle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ToggleText_1 = __importDefault(require("./ToggleText"));
const classnames_1 = __importDefault(require("classnames"));
const bem_helper_1 = require("../../helpers/bem-helper");
const ToggleConstants_1 = require("./ToggleConstants");
const bemHelper = (0, bem_helper_1.BEMClass)(ToggleConstants_1.BASE_TOGGLE_CLASS_NAME);
const MockToggle = ({ areLabelsHidden, checked, offOverrideText, onOverrideText, className }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [areLabelsHidden ? null : (0, jsx_runtime_1.jsx)(ToggleText_1.default, { children: offOverrideText }), (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(bemHelper({ element: "toggle" }), className, {
                [bemHelper({ element: "toggle", state: "selected" })]: checked,
                [bemHelper({ element: "toggle", state: "not-selected" })]: !checked
            }), "aria-hidden": "true" }), areLabelsHidden ? null : (0, jsx_runtime_1.jsx)(ToggleText_1.default, { children: onOverrideText })] }));
exports.MockToggle = MockToggle;
